export function processMessage(message) {
  return (dispatch) => {
    const content = JSON.parse(message.data)
    dispatch({ type: content['stream'], data: content['payload'] })
  }
}

export function updateToken(token) {
  return (dispatch) => {
    dispatch({
      type: 'auth_token',
      token
    })
  }
}

export function authError(error) {
  return (dispatch) => {
    dispatch({
      type: 'auth_error',
      error
    })
  }
}

/** **************** MESSAGES ***************** */
export const NEW_MESSAGE = 'NEW_MESSAGE'
export const EXPIRE_MESSAGE = 'EXPIRE_MESSAGE'
export const CLEAR_MESSAGES = 'CLEAR_MESSAGES'

// eslint-disable-next-line
const generateUUID = () =>
  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    // eslint-disable-next-line
    var r = (Math.random() * 16) | 0,
      v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })

export function createMessage(message, expiration = 0) {
  return (dispatch) => {
    const {
      type = 'generic',
      level = 'warning',
      header = '',
      content = '',
      confirmAction = null
    } = message

    const id = generateUUID()

    dispatch({
      type: NEW_MESSAGE,
      data: { id, type, level, header, content, confirmAction }
    })
    if (expiration) setTimeout(() => dispatch(deleteMessage(id)), expiration)
  }
}

export function deleteMessage(messageId) {
  return (dispatch) => {
    dispatch({
      type: EXPIRE_MESSAGE,
      data: messageId
    })
  }
}

export function clearMessages() {
  return (dispatch) => {
    dispatch({
      type: CLEAR_MESSAGES
    })
  }
}
